var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"floatLayer"},[_c('a',{staticClass:"close-btn",attrs:{"href":"javascript:;"},on:{"click":function($event){$event.stopPropagation();return _vm.closeView.apply(null, arguments)}}},[_vm._v("×")]),_c('img',{staticStyle:{"width":"250px"},attrs:{"src":_vm.json.src,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }